export enum RegisterStateViewPhase {
  CREATE_PASSWORD = 'create-password',
  VERIFY_EMAIL = 'verify-email',
  VERIFY_CODE = 'verify-code',
  SUCCESS = 'success',
}
